'use strict';

(function () {
  'use strict';
  /**
   * This keeps track of the imgix query params that we use with certain image types
   */

  angular.module('msTracker').constant('highchartsAssessmentConf', {
    chart: {
      type: 'spline'
    },
    title: {
      text: 'Wellness Assessment Results'
    },
    accessibility: {
      point: {
        descriptionFormatter: function descriptionFormatter(p) {
          return p.series.name + ', Score: ' + p.y + ', Date: ' + moment(p.x).format('LLL');
        }
      }
    },
    xAxis: {
      type: 'datetime',
      labels: {
        format: '{value:%b %d}',
        align: 'right',
        rotation: -30
      }
    },
    yAxis: {
      title: {
        text: 'Score'
      },
      min: 0,
      accessibility: {
        description: "Score"
      }
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
          radius: 8
        },
        pointStart: moment().subtract(3, 'months').valueOf()
      }
    },
    tooltip: {
      headerFormat: '<b>{series.name}</b><br>',
      pointFormat: 'date: {point.x:%b %e} <br /> score: {point.y}'
    },
    responsive: {
      rules: [{
        condition: {
          maxWidth: 1000
        }
      }]
    },
    series: []
  });
})();